<template>
  <rest-list :payload="listEndpoint">
    <rest-list-column
      prop="id"
      :title="$t('ActionQualification_Field_Id')"
      :width="200"
    />

    <rest-list-column
      v-if="!campaignId"
      prop="campaign_title"
      :title="$t('ActionQualification_Field_Campaign')"
      :min-width="300"
      :tooltip="true"
    />

    <rest-list-column
      prop="profile_id"
      :title="$t('ActionQualification_Field_Profile')"
      :route="profileRoute"
      :min-width="300"
    />

    <rest-list-column-enum
      prop="status"
      :title="$t('ActionQualification_Field_Status')"
      :enum="qualificationStatusLabels"
      :width="200"
    />

    <rest-list-column-date
      prop="create_time"
      :title="$t('ActionQualification_Field_CreateTime')"
      :width="200"
    />

    <rest-list-column
      prop="trigger_event_uuid"
      :title="$t('ActionQualification_Field_TriggerEventUuid')"
      :width="300"
    />

    <rest-list-column-date
      prop="interval_start"
      :title="$t('ActionQualification_Field_IntervalStart')"
      :width="200"
    />

    <rest-list-column-date
      prop="interval_end"
      :title="$t('ActionQualification_Field_IntervalEnd')"
      :width="200"
    />

    <rest-list-column-date
      prop="expiration_time"
      :title="$t('ActionQualification_Field_ExpirationTime')"
      :width="200"
    />

    <rest-list-column-date
      prop="completion_time"
      :title="$t('ActionQualification_Field_CompletionTime')"
      :width="200"
    />

    <rest-list-column
      prop="completion_trigger_id"
      :title="$t('ActionQualification_Field_CompletionTriggerId')"
      :rout="completionTriggerRoute"
      :width="200"
    />
  </rest-list>
</template>

<script>
import RestListColumnDate from '@/common/components/rest/RestListColumnDate'
import RestList from '@/common/components/rest/RestList'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnEnum from '@/common/components/rest/RestListColumnEnum'
import { projectRoute, projectEndpoint } from '@/core/helpers'
import { qualificationStatusLabels } from '../enum/QualificationStatusEnum'

export default {
  name: 'QualificationList',

  components: {
    RestListColumnEnum,
    RestList,
    RestListColumn,
    RestListColumnDate
  },

  data() {
    return {
      qualificationStatusLabels
    }
  },

  props: {
    campaignId: {
      required: false
    }
  },

  computed: {
    listEndpoint() {
      if (this.campaignId) {
        return projectEndpoint({
          method: 'get',
          url: `action-qualifications`,
          params: {
            campaign_id: this.campaignId,
            sort: '-create_time'
          }
        })
      } else {
        return projectEndpoint({
          method: 'get',
          url: `action-qualifications`,
          params: {
            expand: 'campaign_title',
            sort: '-create_time'
          }
        })
      }
    }
  },

  methods: {
    profileRoute(row) {
      return projectRoute({
        name: 'ProfileOverview',
        query: {
          profile_id: row.profile_id
        }
      })
    },

    completionTriggerRoute(row) {
      return projectRoute({
        name: 'CampaignTriggers',
        query: {
          id: row.completion_trigger_id
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/notifications-log/components/QualificationList.vue